import React from "react";
import { ExternalLink, FileText, PlayCircle } from "lucide-react";

const embed = (url) => {
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  const gd = url.match(/drive\.google\.com\/file\/d\/([\w-]+)/);
  if (gd) return `https://drive.google.com/file/d/${gd[1]}/preview`;
  return "";
};
const isVideoFile = (url) => /\.(mp4|webm|mov|m4v)(\?|$)/i.test(url);

export const ResourceList = ({ recursos, testid }) => {
  if (!recursos?.length) return null;
  return (
    <div className="mt-4 space-y-3" data-testid={testid}>
      {recursos.map((r, i) => {
        const src = embed(r.url);
        if (src || isVideoFile(r.url)) {
          return (
            <div key={i} className="rounded-2xl overflow-hidden ring-1 ring-black/10 bg-black" data-testid={`${testid}-video-${i}`}>
              {src ? <iframe src={src} title={r.titulo || "Video"} className="w-full aspect-video" allow="autoplay; encrypted-media; fullscreen" allowFullScreen />
                : <video src={r.url} controls className="w-full aspect-video" />}
              {r.titulo && <div className="bg-[#0A1C30] text-white text-sm font-bold px-4 py-2 flex items-center gap-2"><PlayCircle className="w-4 h-4 text-[var(--gold)]" /> {r.titulo}</div>}
            </div>
          );
        }
        return (
          <a key={i} href={r.url} target="_blank" rel="noreferrer" data-testid={`${testid}-link-${i}`}
            className="flex items-center gap-3 rounded-2xl ring-1 ring-black/10 bg-white hover:ring-[#B99B2E] px-4 py-3 transition-colors">
            <FileText className="w-5 h-5 text-[#B99B2E] shrink-0" />
            <span className="flex-1 min-w-0 font-bold text-sm text-[#0A1C30] truncate">{r.titulo || r.url}</span>
            <ExternalLink className="w-4 h-4 text-[#6B7688]" />
          </a>
        );
      })}
    </div>
  );
};
